import { useRouter } from 'next/router';
import Image from 'components/shared/image';
import SiteLink from 'components/shared/sitelink';
import { addLocaleToHref } from 'lib/utils/helpers';
import styles from './outOfStockPopup.module.scss';

const OutOfStockPopup = ({ locale, closeModal, outOfStockProducts, globalModule }) => {
  const router = useRouter();
  const { outOfStockPopupBodyText, outOfStockPopupCancelText, outOfStockPopupShopOtherText } =
    globalModule;

  const handleModal = () => {
    closeModal(false);
  };

  return (
    <div
      role="button"
      tabIndex="0"
      alt="overlay"
      className={styles.overlay}
      onClick={handleModal}
      onKeyDown={handleModal}
    >
      <div className={styles.container}>
        <div className={styles.containerFlex}>
          {outOfStockProducts.map(({ image, productTitle }) => (
            <>
              <div className={styles.productImage}>
                <Image src={image} loading="eager" layout="fill" priority sizes="25vw" />
              </div>
              <div className={styles.productInfo}>
                <span className={styles.title}>{productTitle}</span>
                <span className={styles.bodyText}>{outOfStockPopupBodyText.text}</span>
              </div>
            </>
          ))}
        </div>
        <div className={styles.buttonsSection}>
          <button type="button" onClick={closeModal}>
            {outOfStockPopupCancelText.text}
          </button>
          <SiteLink locale={locale} href={addLocaleToHref('/producten', locale, router)}>
            <button type="button" onClick={handleModal}>
              {outOfStockPopupShopOtherText.text}
            </button>
          </SiteLink>
        </div>
      </div>
    </div>
  );
};

export default OutOfStockPopup;
